import "./About.css"
import question from "../simone-secci-49uySSA678U-unsplash.jpg"
import { useEffect, useState } from "react";

const mouseOver = event => {
    const fact = event.target;
    fact.style.color = "white";
}

export default function About() {

    const [isMobile, setMobile] = useState(window.innerWidth <= 650);

    const updateMobile = () => {
        setMobile(window.innerWidth <= 650)
    }

    useEffect(() => {
        window.addEventListener("resize", updateMobile)
    })

    return (
        <div className="aboutContainer">
            {isMobile ? (
                <h2>Tap the screen to learn more about me!</h2>
            ): (
                <h2>Mouse around to learn more about me!</h2>
            )}
            <div className="imgContainer">
                <img src={question} alt="blank" />
            </div>
            <p className="fact1" onMouseEnter={(event) => mouseOver(event)}>My favorite show is Seinfeld!</p>
            <p className="fact2" onMouseEnter={(event) => mouseOver(event)}>I'm currently learning bass!</p>
            <p className="fact3" onMouseEnter={(event) => mouseOver(event)}>I have a B.S. in Psychology with a Leadership minor!</p>
            <p className="fact4" onMouseEnter={(event) => mouseOver(event)}>Previous jobs I've had include: barback, orientation staff, working on a Christmas tree farm, delivery driver, painter/roofer, soccer ref, and many more odd jobs!</p>
            <p className="fact5" onMouseEnter={(event) => mouseOver(event)}>Graduating high school class size was 36 (very small farm town)!</p>
            <p className="fact6" onMouseEnter={(event) => mouseOver(event)}>Some hobbies include: working out, reading, gaming, board games, bar trivia, music!</p>
            <p className="fact7" onMouseEnter={(event) => mouseOver(event)}>My favorite dessert is tiramisu!</p>
        </div>
    )
}